<header id="site-header">
    <div class="container">
        <h2 class="logo" [style.background-image]='logo'>Your Medical Group</h2>
    </div>
</header>
<app-title *ngIf="title" [title]="title" [subtitle]="subtitle"></app-title>
